const lightTheme = {
  colors: {
    background: '#fff',
    sidebar: '#1F2027',
    heading: '#000',
    sidebarText: '#adadad',
    text: '#1f2027',
    preFormattedText: 'rgb(245, 247, 249)',
    //highlight: '#1F2027',
    link: '#1F2027',
  },
};

export { lightTheme };
